export enum SubscriptionsPeriod {
  MONTHLY = "MONTHLY",
  ANUALLY = "ANUALLY",
}
export interface SubscriptionsInput {
  planId: string;
  organizationId: string;
  allowAdditional: boolean;
  period: SubscriptionsPeriod;
  couponId?: string;
}

export interface SubscriptionsOutput {
  invoiceId: string;
  integrationId: string;
  initPoint: string;
}
